import type {
  StandingConsentAcceptanceHintsDto,
  StandingConsentActiveStatusDto,
} from '../core/events';
import { HttpClient } from './http';

export interface PhoneStandingConsentsService {
  getAcceptanceHints: (
    phones: string[],
  ) => Promise<StandingConsentAcceptanceHintsDto>;
  getActiveStatus: () => Promise<StandingConsentActiveStatusDto>;
  revokeAllActive: () => Promise<void>;
}

export function createPhoneStandingConsentsService(
  httpClient: HttpClient,
  baseUrl: string,
): PhoneStandingConsentsService {
  return {
    getAcceptanceHints: (phones) => {
      const query =
        phones.length > 0 ? { phones: phones.join(',') } : undefined;
      return httpClient<StandingConsentAcceptanceHintsDto>(
        `${baseUrl}/phone-standing-consents/acceptance-hints`,
        'get',
        { query },
      );
    },
    getActiveStatus: () =>
      httpClient<StandingConsentActiveStatusDto>(
        `${baseUrl}/phone-standing-consents/active-status`,
        'get',
      ),
    revokeAllActive: () =>
      httpClient<void>(`${baseUrl}/phone-standing-consents/active`, 'delete'),
  };
}
